import type DB from '../DB';

export async function deleteUserScheduledActions(db: DB<any>, userId: string): Promise<void> {
    const metainfoMVCC = await db.metainfoMVCC.fetchMetainfoMVCC(userId);

    const scheduledActionKeys = Object.values({
        ...metainfoMVCC?.scheduledActionNotifications,
        ...metainfoMVCC?.systemScheduledActionNotifications,
    });

    await db.scheduledActions.deleteBatch(scheduledActionKeys);
}
